import { useEffect, useState } from "react";
import { apiRequest } from "../../shared/api/client";
import { cashMovementsSchema } from "../../../shared/account-finance/daily-cash-contract";
import type { CashMovements } from "../../../shared/account-finance/daily-cash-contract";

export function useCashMovementsWorkspace(date: string) {
  const [page, setPage] = useState<number | null>(null);
  const [version, setVersion] = useState(0);
  const [detail, setDetail] = useState<CashMovements | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    const controller = new AbortController();
    if (page === null) { setLoading(false); return () => controller.abort(); }
    setLoading(true); setError(null); setDetail(null);
    void apiRequest<unknown>(`/api/account-finance/cash/movements?date=${date}&page=${page}`,
      { signal: AbortSignal.any([controller.signal, AbortSignal.timeout(15_000)]) })
      .then((raw) => { if (!controller.signal.aborted) setDetail(cashMovementsSchema.parse(raw)); })
      .catch((failure: unknown) => { if (!controller.signal.aborted) setError(failure instanceof Error ? failure.message : "Hareketler okunamadı."); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [date, page, version]);
  return { page, setPage, detail, loading, error, retry: () => setVersion((value) => value + 1) };
}
